import { Component, inject } from '@angular/core';
import { BoelsUserTypeEnum } from '@boels/models';
import { MatDialogRef } from '@angular/material/dialog';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ModalModule } from '@boels/helpers';
import { faUser, faUserTie } from '@fortawesome/free-solid-svg-icons';
import { ButtonComponent } from '../button/button.component';

@Component({
  imports: [TranslocoModule, FontAwesomeModule, ModalModule, ButtonComponent],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: ['header'],
    },
  ],
  selector: 'boels-user-type-modal',
  templateUrl: './user-type-modal.component.html',
  styleUrls: ['./user-type-modal.component.scss'],
})
export class UserTypeModalComponent {
  dialogRef = inject<MatDialogRef<UserTypeModalComponent>>(MatDialogRef);

  userTypeEnum = BoelsUserTypeEnum;
  fasUserTie = faUserTie;
  faUser = faUser;

  closeModal(userType: string): void {
    this.dialogRef.close(userType.toUpperCase());
  }
}
